var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-controls"},[_c('GruButton',{attrs:{"disabled":!_vm.gameStarted},on:{"click":function($event){return _vm.$emit('reset')}}},[_vm._v(" New Game ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }